<div class="left-gap">
  <!-- <mat-form-field >
    <mat-label>Organization Folder Name</mat-label>
    <input matInput>
  </mat-form-field> -->
  <!-- <span class="form-label">Organization Folder Name: Test</span> -->
</div>

<div class="segmented-tabs" style="margin-left: 15px;">
  <button class="seg-tab"
          [class.active]="activeTab === 'ftp'"
          (click)="selectTab('ftp')">
    FTP
  </button>

  <button class="seg-tab"
          [class.active]="activeTab === 'db'"
          (click)="selectTab('db')">
    Database
  </button>

  <button class="seg-tab"
          [class.active]="activeTab === 'api'"
          (click)="selectTab('api')">
    Rest API
  </button>
</div>

<!-- ================= FTP TAB ================= -->
<app-ftp-setup *ngIf="activeTab === 'ftp'"></app-ftp-setup>

<!-- ================= DB TAB ================= -->
<fieldset class="outer-box" *ngIf="activeTab === 'db'">
  <app-sql-data-connector></app-sql-data-connector>
</fieldset>
